/**
 * WidgetRenderer — lookup central key → componente (R-IMPORT 3 / A3.3).
 *
 * Recebe widget metadata + perfilUsuario, retorna o componente certo do
 * registry. Fallback render pra keys desconhecidas.
 */
import type { Widget } from '@/lib/dashboard/layouts-api';

import type { PerfilUsuario } from './registry';
import { WIDGET_RENDERERS } from './renderer-map';
import { WidgetShell } from './WidgetShell';

interface WidgetRendererProps {
  widget: Widget;
  perfilUsuario: PerfilUsuario;
  isEditing: boolean;
  onRemove?: () => void;
}

export function WidgetRenderer(props: WidgetRendererProps) {
  const Component = WIDGET_RENDERERS[props.widget.key];

  if (!Component) {
    return (
      <WidgetShell
        title={`Widget desconhecido: ${props.widget.key}`}
        error={`Renderer não registrado pra key '${props.widget.key}'.`}
        testId={`widget-unknown-${props.widget.key}`}
      />
    );
  }

  return (
    <div className="relative w-full h-full">
      <Component perfilUsuario={props.perfilUsuario} />
      {props.isEditing && props.onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            props.onRemove!();
          }}
          data-testid={`widget-remove-${props.widget.key}`}
          className="absolute top-1 right-1 z-10 w-6 h-6 rounded-full bg-paper-surface dark:bg-paper-dark-surface border border-line dark:border-line-dark hover:bg-red-soft dark:hover:bg-red-soft-dark hover:border-red text-red dark:text-red-glow text-xs shadow-sm"
          title="Remover da grid"
        >
          ✕
        </button>
      )}
    </div>
  );
}
